// Códigos de país que ofrecen los formularios con celular.
export const DEFAULT_COUNTRY_PHONE_CODE = '+593'

export const COUNTRY_PHONE_CODES = [
  { icon: '🇪🇨', label: 'Ecuador', value: '+593' },
  { icon: '🇨🇴', label: 'Colombia', value: '+57' },
  { icon: '🇲🇽', label: 'México', value: '+52' },
  { icon: '🇵🇪', label: 'Perú', value: '+51' },
  { icon: '🇦🇷', label: 'Argentina', value: '+54' },
]
